<template>
  <div class="display-flex w90p flex-column-mb" :class="minimize ? 'flex-column' : ''">
    <div v-if="vitalsLength" class="display-flex w100p flex-wrap-dk justify-between bt-grey scroll-x-auto" :class="minimize ? 'bv-grey' : 'w20p-dk bh-grey'">
      <div class="text-center w25p w48p-tb border-none-dk pointer"
        :class="{
          'w100p-dk minw25 pa2-mb ma2-mb pa1 mb1-mb border-grey br0-5-mb': !minimize,
          'pv1 pr1': minimize,
          'bg-violet text-white': key === selectedTab,
          'bb-grey': !minimize && key === 'sulphurDioxide',
          'needs-attention': key === selectedTab && tab.is_alert_triggered }"
        v-for="(tab, key) in tabOptions"
        @click="selectTab(key)"
        :key="key">
        <div class="display-flex align-center justify-center text-center w100p" v-if="!minimize">
          <span class="mr1"
            :class="{
              'text-white': key === selectedTab,
              'text-danger' : key === selectedTab && tab.is_alert_triggered,
              'text-violet': key !== selectedTab
            }"
          >
            {{ tab.name }}
          </span>
        </div>
        <div class="text-center display-flex justify-center align-center w100p f1-5" :class="tab.is_alert_triggered ? 'text-danger' : ''">
          <span v-if="!minimize" class="vertical-align-sub f2 mt1">
            {{ tab.value }}
            <span class="f1-3"> {{ tab.unit }}</span>
          </span>
          <bh-icon :icon="tab.vital" class="f1-7 ml1" :class="{
            [`text-${tab.vital}`]: tab.key !== selectedTab,
            'text-white': key === selectedTab,
            'text-danger': key === selectedTab && tab.is_alert_triggered,
            'f2 pt0-3': !minimize
            }"
          />
          <span v-if="minimize" class="pl0-3 ml0-5">
            {{ tab.value }}
            <span class="f1-5 mt1-3"> {{ tab.unit }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="display-flex flex-column justify-center" v-if="optionsData[selectedTab]" :class="minimize ? 'w100p h35 f1' : 'w100p w100p-mb w100p-tb minh50 ph2 pa1-mb'">
      <bh-legends v-if="vitalsLength" class="mr2 mv2" :legends="tabLegends" :primaryModel="primaryModel"/>
      <bh-chart
        v-if="optionsData[selectedTab] && vitalsLength"
        :options="optionsData[selectedTab]"
        ref="chartRef"
        @onBrushEnd="onBrushEnd"
        @chartClicked="chartClicked"
      />
      <div class="text-danger f2" v-if="!vitalsLength">No Data Available</div>
      <div class="display-flex align-center flex-column-mb" :class="{'justify-center':customDateSet,'mt5': !vitalsLength}">
        <bh-horizontal-timebar class="mr2" v-if="!customDateSet || isInvalidCustomDate" :selectedKey="timeKey" :data="timesData" @output="onRangeClick" />
        <bh-date-time-picker
          v-if="(!minimize && vitalsLength && vitals.length && (vitalsLength - 10 <= vitals.length || vitals.length >= vitalsLength)) || (!vitalsLength && customDateSet)"
          :dateRange="dateRange"
          :isInvalidCustomDate="isInvalidCustomDate"
          @pickDateAndTime="onDateAndTimePick"
          @onResetVitals="resetVitals"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { tabOptions } from '@/services/device-details'
import Legends from './Legends'
import moment from '@/utils/moment'

export default {
  name: 'bh-vitals-chart-detailed-view',
  components: {
    'bh-legends': Legends
  },
  props: {
    minimize: {
      type: Boolean,
      default: false
    },
    optionsData: {
      type: Object,
      default() {
        return {}
      }
    },
    alertId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'chartDetail'
    },
    timeKey: {
      type: String,
      default: 'All'
    },
    timesData: {
      type: Array | Object,
      default() {
        return {}
      }
    },
    primaryModel: {
      type: String
    },
    isInvalidCustomDate: false,
    isCustomDate: false,
    dateRange: {}
  },
  data () {
    return {
      selectedTab: 'temperature',
      tabOptions: {},
      coordRange: []
    }
  },
  computed: {
    ...mapGetters('device', ['device', 'vitals', 'submittedFeedbacks', 'brushCoords', 'brushCoordIndex', 'customDateSet', 'vitalsLength']),
    tabLegends() {
      return this.tabOptions[this.selectedTab]?.legends
    }
  },
  watch: {
    brushCoordIndex(newVal, oldVal) {
      this.emitBrushEvent()
    },
    isInvalidCustomDate(newVal, oldVal) {
      if (newVal) {
        this.setToast(['toast', { duration: 6000, show: true, message: `No data available for ${this.customDate}`, color: '#F44336' }])
        this.$emit('clearError')
      }
    },
    vitals(newValue, oldValue) {
      if (this.vitals && this.vitalsLength && this.vitals.length >= this.vitalsLength) {
        setImmediate(this.emitBrushEvent)
      }
    }
  },
  beforeMount() {
    const options = {}
    for (const key in tabOptions) {
      const tab = tabOptions[key]
      const value = this.device[key]?.value
      tab.is_alert_triggered = this.device[key]?.is_alert_triggered
      if (tab.is_alert_triggered) this.selectTab(key)
      tab.value = value
      options[key] = tab
    }
    this.tabOptions = options
  },
  methods: {
    ...mapActions({ setToast: 'setSingleProperty' }),
    ...mapActions('device', ['setSingleProperty', 'getMinMaxDate']),
    onBrushEnd(event) {
      const [brush] = event.areas
      if (brush.coordRange) {
        this.coordRange = brush.coordRange
      }
      this.$emit('onBrushEnd', { event, refs: this.$refs })
    },
    selectTab(key) {
      this.selectedTab = key
      setImmediate(() => {
        this.onBrushEnd({ areas: [{ coordRange: this.coordRange }] })
      })
    },
    onRangeClick({ key, value }) {
      this.$emit('onTimeRange', { key, time: value, selectedTab: this.selectedTab })
    },
    chartClicked(event) {
      this.$emit('chartClicked', event)
    },
    emitBrushEvent() {
      const { startDateIndex, endDateIndex } = this.brushCoords[this.brushCoordIndex] || {}
      if (startDateIndex && endDateIndex) {
        this.onBrushEnd({ areas: [{ coordRange: [startDateIndex, endDateIndex] }] })
      }
    },
    onDateAndTimePick(e) {
      this.setSingleProperty(['customDateSet', true])
      this.customDate = moment.formatDate(e, 'DD MMM, YYYY, HH:mm:ss')
      const selectedHour = new Date(e).getHours()
      this.$emit('onCustomDatePick',
        {
          startTime: new Date(new Date(e).setHours(selectedHour - 2)).getTime(),
          endTime: new Date(new Date(e).setHours(selectedHour + 2)).getTime(),
          selectedTab: this.selectedTab
        }
      )
    },
    resetVitals() {
      this.setSingleProperty(['customDateSet', false])
      this.$emit('onResetVital', true)
    }
  }
}
</script>

<style scoped>
  .range-times {
    border: 1px solid #5764b3;
  }

  .time-label {
    background-color: #5764b3;
    color: #ffffff;
    margin: 1px;
  }

  .bv-grey {
    border-top: .5px solid #c2c2c2;
    border-bottom: .5px solid #c2c2c2;
  }

  @media (min-width: 1024px) {
    .bh-grey {
      border-right: .5px solid #c2c2c2;
      border-left: .5px solid #c2c2c2;
    }

    .bt-grey {
      border-top: .5px solid #c2c2c2;
    }

    .bb-grey {
      border-bottom: .5px solid #c2c2c2;
    }
  }
</style>
